import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";
import { AppShell } from "./components/AppShell";
import { ToastProvider } from "./components/Toast";
import { Boot } from "./Boot";
import { AppRoutes } from "./routes";
import { watchViewport } from "./telegram/viewport";
import { AuthError } from "./api/errors";
import { useT } from "./i18n/strings";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // A phone on mobile data drops requests; a rejected signature never
      // becomes valid, so only the first kind is worth retrying.
      retry: (count, error) => count < 2 && !(error instanceof AuthError),
      refetchOnWindowFocus: false,
      // Comfortably under the hour a signed media url lives, so a record coming
      // back out of this cache can never be holding a dead one.
      gcTime: 10 * 60_000,
    },
  },
});

export default function App() {
  const t = useT();
  useEffect(() => watchViewport(), []);
  // The tab title is the one piece of chrome outside the React tree.
  useEffect(() => {
    document.title = t.appName;
  }, [t]);

  return (
    <QueryClientProvider client={client}>
      {/* "user" honours prefers-reduced-motion for every animation at once,
          rather than each component checking for itself. */}
      <MotionConfig reducedMotion="user">
        <ToastProvider>
          <Boot>
            <BrowserRouter>
              <AppShell>
                <AppRoutes />
              </AppShell>
            </BrowserRouter>
          </Boot>
        </ToastProvider>
      </MotionConfig>
    </QueryClientProvider>
  );
}
